import React, { useMemo, useState } from "react";
import HeaderFilter from "./HeaderFilter";
import Pagination from "./Pagination";
import { LuPencil } from "react-icons/lu";
import { IoBan } from "react-icons/io5";
import { GoTrash } from "react-icons/go";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { allCountries } from "country-telephone-data";
// import profile_Img from "../../../../../../Assets/Images/profile_Img.png";
import profile_Img from "../../../../../Assets/Images/profile_Img.png";

const userData = [
  {
    name: "Emily Rose",
    email: "emilyRose@toner.com",
    phone: "+91 987 654 3210",
    date: "02 Jan, 2023",
    country: "United States",
    avatar: "https://i.pravatar.cc/150?img=1",
  },
  {
    name: "Edward Davidson",
    email: "Edward Davidson@toner.com",
    phone: "+1 987 654 3210",
    date: "05 Jan, 2023",
    country: "Canada",
    avatar: "https://i.pravatar.cc/150?img=2",
  },
  {
    name: "Angela Kelly",
    email: "Angela Kelly@toner.com",
    phone: "+44 987 654 3210",
    date: "4 Jan, 2023",
    country: "United Kingdom",
    avatar: "https://i.pravatar.cc/150?img=3",
  },
  {
    name: "Michael Smith",
    email: "michaelSmith@toner.com",
    phone: "+61 987 654 3210",
    date: "10 Jan, 2023",
    country: "Australia",
    avatar: "https://i.pravatar.cc/150?img=4",
  },
  {
    name: "Sophia Turner",
    email: "sophiaTurner@toner.com",
    phone: "+49 987 654 3210",
    date: "12 Jan, 2023",
    country: "Germany",
    avatar: "https://i.pravatar.cc/150?img=5",
  },
  {
    name: "Liam Johnson",
    email: "liamJohnson@toner.com",
    phone: "+33 987 654 3210",
    date: "15 Jan, 2023",
    country: "France",
    avatar: "https://i.pravatar.cc/150?img=6",
  },
  {
    name: "Olivia Martinez",
    email: "oliviaMartinez@toner.com",
    phone: "+34 987 654 3210",
    date: "18 Jan, 2023",
    country: "Spain",
    avatar: "https://i.pravatar.cc/150?img=7",
  },
  {
    name: "Noah Wilson",
    email: "noahWilson@toner.com",
    phone: "+81 987 654 3210",
    date: "20 Jan, 2023",
    country: "Japan",
    avatar: "https://i.pravatar.cc/150?img=8",
  },
  {
    name: "Isabella Brown",
    email: "isabellaBrown@toner.com",
    phone: "+61 987 654 3210",
    date: "25 Jan, 2023",
    country: "Australia",
    avatar: "https://i.pravatar.cc/150?img=9",
  },
  {
    name: "Mia Davis",
    email: "miaDavis@toner.com",
    phone: "+1 234 567 8901",
    date: "28 Jan, 2023",
    country: "United States",
    avatar: "https://i.pravatar.cc/150?img=10",
  },
];

export default function DashboardTable({
  users,
  isLoading,
  currentPage,
  totalPages,
  totalUsers,
  getUserList,
  selectedTime,
  setSelectedTime,
}) {
  const getCountryFromPhoneCode = (code) => {
    const phoneCode = code.replace("+", "");
    const match = allCountries.find((c) => c.dialCode === phoneCode);
    return match ? match.name : "Unknown";
  };

  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const sortedData = useMemo(() => {
    return [...users].sort((a, b) => {
      if (sortConfig.key === "createdAt") {
        return sortConfig.direction === "asc"
          ? new Date(a.createdAt) - new Date(b.createdAt)
          : new Date(b.createdAt) - new Date(a.createdAt);
      }
      if (sortConfig.key === "countryCode") {
        return sortConfig.direction === "asc"
          ? a.countryCode.localeCompare(b.countryCode)
          : b.countryCode.localeCompare(a.countryCode);
      }
      if (a[sortConfig.key].toLowerCase() < b[sortConfig.key].toLowerCase())
        return sortConfig.direction === "asc" ? -1 : 1;
      if (a[sortConfig.key].toLowerCase() > b[sortConfig.key].toLowerCase())
        return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [sortConfig, users]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  return (
    <section>
      <HeaderFilter
        getUserList={getUserList}
        selectedTime={selectedTime}
        setSelectedTime={setSelectedTime}
      />
      <div
        className={`overflow-x-auto ${
          isLoading ? "h-screen overflow-hidden" : ""
        }`}
      >
        <table className="min-w-full whitespace-nowrap border-0 rounded-md">
          <thead className="bg-[#F9F7FF] border-b-0 text-sm font-medium text-gray-700">
            <tr className="border-b-0">
              {" "}
              {/* NO flex here */}
              <th
                className="px-4 py-4 font-medium cursor-pointer select-none"
                onClick={() => handleSort("name")}
              >
                <div className="flex items-center gap-2">
                  User Name
                  {sortConfig.key === "name" ? (
                    sortConfig.direction === "asc" ? (
                      <FaSortUp />
                    ) : (
                      <FaSortDown />
                    )
                  ) : (
                    <FaSort className="text-gray-300" />
                  )}
                </div>
              </th>
              <th
                className="px-4 py-4 font-medium cursor-pointer select-none"
                onClick={() => handleSort("email")}
              >
                <div className="flex items-center gap-2">
                  Email Address
                  {sortConfig.key === "email" ? (
                    sortConfig.direction === "asc" ? (
                      <FaSortUp />
                    ) : (
                      <FaSortDown />
                    )
                  ) : (
                    <FaSort className="text-gray-300" />
                  )}
                </div>
              </th>
              <th
                className="px-4 py-4 font-medium cursor-pointer select-none"
                onClick={() => handleSort("gender")}
              >
                <div className="flex items-center gap-2">
                  Gender
                  {sortConfig.key === "gender" ? (
                    sortConfig.direction === "asc" ? (
                      <FaSortUp />
                    ) : (
                      <FaSortDown />
                    )
                  ) : (
                    <FaSort className="text-gray-300" />
                  )}
                </div>
              </th>
              <th
                className="px-4 py-4 font-medium cursor-pointer select-none"
                onClick={() => handleSort("phone")}
              >
                <div className="flex items-center gap-2">
                  Phone Number
                  {sortConfig.key === "phone" ? (
                    sortConfig.direction === "asc" ? (
                      <FaSortUp />
                    ) : (
                      <FaSortDown />
                    )
                  ) : (
                    <FaSort className="text-gray-300" />
                  )}
                </div>
              </th>
              <th
                className="px-4 py-4 font-medium cursor-pointer select-none"
                onClick={() => handleSort("createdAt")}
              >
                <div className="flex items-center gap-2">
                  Create Date
                  {sortConfig.key === "createdAt" ? (
                    sortConfig.direction === "asc" ? (
                      <FaSortUp />
                    ) : (
                      <FaSortDown />
                    )
                  ) : (
                    <FaSort className="text-gray-300" />
                  )}
                </div>
              </th>
              <th
                className="px-4 py-4 font-medium cursor-pointer select-none"
                onClick={() => handleSort("countryCode")}
              >
                <div className="flex items-center gap-2">
                  Country
                  {sortConfig.key === "countryCode" ? (
                    sortConfig.direction === "asc" ? (
                      <FaSortUp />
                    ) : (
                      <FaSortDown />
                    )
                  ) : (
                    <FaSort className="text-gray-300" />
                  )}
                </div>
              </th>
              {/* <th className="px-4 py-4 font-medium">Action</th> */}
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {isLoading ? (
              <tr>
                <td colSpan="6" className="text-center p-5 bg-white">
                  Loading...
                </td>
              </tr>
            ) : sortedData.length > 0 ? (
              sortedData.map((user, index) => (
                <tr
                  key={user._id}
                  className={`bg-white hover:bg-gray-50 ${
                    index === 0 ? "border-t-0" : ""
                  }`}
                >
                  {" "}
                  <td
                    className={`px-4 py-4 ${
                      index === 0 ? "rounded-tl-none border-b-0" : ""
                    } ${
                      index === sortedData.length - 1 ? "rounded-bl-none" : ""
                    }`}
                  >
                    {" "}
                    <div className="flex items-center gap-3">
                      <img
                        src={user.userImage || user.avtarImage || profile_Img}
                        alt={user.name}
                        className="w-8 h-8 rounded-full object-cover"
                      />
                      <span>{user.name}</span>
                    </div>
                  </td>
                  <td className="px-4 py-4">{user.email || "-"}</td>
                  <td className="px-4 py-4">{user.gender || "-"}</td>
                  <td className="px-4 py-4">{user.phone || "-"}</td>
                  <td className="px-4 py-4">
                    {user.createdAt ? formatDate(user.createdAt) : "-"}
                  </td>
                  <td className="px-4 py-4">
                    {user.countryCode
                      ? getCountryFromPhoneCode(user.countryCode)
                      : "-"}
                  </td>
                  {/* <td
                  className={`px-4 py-4 flex items-center gap-3 text-gray-600 ${
                    index === 0 ? "rounded-t-none" : ""
                  } ${index === userData.length - 1 ? "rounded-br-none" : ""}`}
                >
                  <button
                    title="Edit"
                    className="bg-[#F9F7FF] rounded-md h-[30px] w-[30px] flex items-center justify-center text-[#7104F8] hover:opacity-50"
                  >
                    <LuPencil />
                  </button>
                  <button
                    title="Block"
                    className="bg-[#FFEFEE] rounded-md h-[30px] w-[30px] flex items-center justify-center text-[#F44336] hover:opacity-50"
                  >
                    <IoBan />
                  </button>
                  <button
                    title="Delete"
                    className="bg-[#FFEFEE] rounded-md h-[30px] w-[30px] flex items-center justify-center text-[#F44336] hover:opacity-50"
                  >
                    <GoTrash />
                  </button>
                </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center bg-white py-2">
                  No user found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!isLoading && totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalItems={totalUsers}
          itemsPerPage={10}
          onPageChange={(page) => {
            getUserList(page);
          }}
        />
      )}
    </section>
  );
}
